<template>
    <div class="score">
        <div class="score__row">
            <component :is="iconComponent" class="score__icon" />
            <span class="score__text">{{ text }}</span>
        </div>
        <div class="score__row">
            <span class="score__count">{{ count || 0 }}</span>
            <span class="score__small-text">{{ smallText }}</span>
        </div>
    </div>
</template>

<script>
import FriendsIcon from '../icons/FriendsIcon.vue';
import ScoresIcon from '../icons/ScoresIcon.vue';

export default {
    components: { FriendsIcon, ScoresIcon },
    props: {
        count: {
            type: Number,
            default: 0,
        },
        text: {
            type: String,
            default: '',
        },
        smallText: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
    },

    computed: {
        iconComponent() {
            switch (this.icon) {
                case 'friends':
                    return FriendsIcon;
                case 'scores':
                    return ScoresIcon;
                default:
                    return FriendsIcon;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.score {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: rgba(246, 250, 253, 1);
    border-radius: urem(16);
    padding: 0 urem(16);
    
    height: urem(32);

    @include on-desktop {
        height: urem(96);
        flex-direction: column;
        width: 50%;
        gap: urem(10);
        padding: urem(16);
        align-items: start;
    }

    &__row {
        display: flex;
        align-items: center;
        gap: urem(10);
        
    }

    &__count {
        font-size: urem(24);
        font-weight: 600;
    }

    &__text {
        font-size: urem(10);
        font-weight: 500;
        white-space: nowrap;
        display: flex;
        align-items: center;

        @include on-desktop {
            font-size: urem(14);
        }
    }

    &__small-text {
        font-size: urem(12);
        font-weight: 500;
        color: rgba(152, 160, 169, 1);
    }

    &__icon {
        height: urem(19);
    }
}
</style>
